{
  "panel": {
    "title": "Xtreed Assistant",
    "subtitle": "Builds your courses for you",
    "close": "Collapse assistant",
    "newConversation": "New conversation",
    "conversations": "Conversations",
    "noConversations": "No conversations yet",
    "untitled": "New conversation",
    "deleteConversation": "Delete conversation",
    "deleteConfirm": "Delete this conversation? The courses it created stay in your member area.",
    "loadOlder": "Load earlier messages"
  },
  "empty": {
    "title": "Shall we build your course?",
    "description": "Tell me about the course and send the videos or links. I'll organize modules and lessons, you approve, and I'll upload everything to your member area.",
    "suggestions": {
      "newCourse": "Build a new course",
      "newCoursePrompt": "I want to build a new course in my member area.",
      "addModule": "Add a module to a course",
      "addModulePrompt": "I want to add a module to an existing course.",
      "status": "See my courses",
      "statusPrompt": "Which courses do I have in my member area?"
    },
    "context": {
      "title": "On this course",
      "review": "Review this course's structure",
      "reviewPrompt": "Review the structure of the course I'm viewing and tell me what's missing.",
      "describe": "Write descriptions",
      "describePrompt": "Write descriptions for the course I'm viewing and for its modules.",
      "publish": "Publish this course",
      "publishPrompt": "I want to publish the course I'm viewing. Check if anything is missing first."
    }
  },
  "composer": {
    "label": "Message to the assistant",
    "placeholder": "Describe the course or paste links…",
    "placeholderRunning": "The assistant is replying…",
    "send": "Send",
    "stop": "Stop",
    "attach": "Attach videos, images or materials",
    "dropHere": "Drop the files to upload",
    "removeAttachment": "Remove attachment"
  },
  "message": {
    "typing": "The assistant is writing",
    "aborted": "Reply interrupted.",
    "error": "I couldn't finish this reply. Please try again."
  },
  "tools": {
    "get_member_area_overview": "Checking your courses",
    "get_course_tree": "Reading the course structure",
    "apply_course_plan": "Building the course",
    "create_course": "Creating the course",
    "update_course": "Updating the course",
    "create_module": "Creating module",
    "update_module": "Updating module",
    "reorder_modules": "Reordering modules",
    "create_lesson": "Creating lesson",
    "update_lesson": "Updating lesson",
    "reorder_lessons": "Reordering lessons",
    "move_lesson": "Moving lesson",
    "set_lesson_video_embed": "Linking video",
    "attach_uploaded_video": "Attaching uploaded video",
    "set_course_image": "Setting course image",
    "add_lesson_material": "Adding material",
    "get_upload_status": "Checking uploads",
    "set_course_visibility": "Adjusting visibility",
    "publish_course": "Publishing the course",
    "delete_course": "Deleting the course",
    "delete_module": "Deleting module",
    "delete_lesson": "Deleting lesson",
    "unlink_module": "Removing module from course",
    "unlink_lesson": "Removing lesson from module",
    "get_member_area_link": "Getting the link",
    "archive_course": "Archiving the course",
    "get_course_sales_status": "Checking course sales setup",
    "set_module_image": "Setting module image",
    "list_course_sections": "Checking the showcase",
    "create_course_section": "Creating showcase section",
    "add_course_to_section": "Adding course to showcase",
    "remove_course_from_section": "Removing course from section",
    "list_categories": "Checking categories",
    "create_category": "Creating category",
    "set_course_category": "Setting category",
    "fallback": "Working"
  },
  "approval": {
    "title": "I need your confirmation",
    "approve": "Approve",
    "reject": "Don't do it",
    "adjust": "Ask for changes",
    "adjustPlaceholder": "What would you like to change?",
    "sendAdjust": "Send changes",
    "cancel": "Cancel",
    "approved": "Approved",
    "rejected": "Declined",
    "edited": "Approved with changes",
    "expired": "This confirmation expired",
    "actions": {
      "publish_course": "Publish the course to the member area",
      "set_course_visibility": "Change the visibility of a published course",
      "delete_course": "Delete a course",
      "delete_module": "Delete a module",
      "delete_lesson": "Delete a lesson",
      "unlink_module": "Remove a module from the course",
      "unlink_lesson": "Remove a lesson from the module",
      "archive_course": "Take the course offline (archive)",
      "fallback": "Run an action"
    },
    "visibilityTo": "New visibility: {{value}}"
  },
  "plan": {
    "title": "Proposed structure",
    "existingCourse": "New modules for an existing course",
    "modules_one": "{{count}} module",
    "modules_zero": "{{count}} modules",
    "modules_other": "{{count}} modules",
    "lessons_one": "{{count}} lesson",
    "lessons_zero": "{{count}} lessons",
    "lessons_other": "{{count}} lessons",
    "videoLink": "Video by link",
    "videoUpload": "Uploaded video",
    "noVideo": "No video",
    "free": "Free",
    "visibility": {
      "HIDDEN": "Hidden from non-buyers",
      "LOCKED": "Visible with a lock"
    },
    "editHint": "You can edit the titles before approving.",
    "moduleLabel": "Module {{index}}"
  },
  "uploads": {
    "title": "Files",
    "status": {
      "PENDING": "Waiting",
      "UPLOADING": "Uploading",
      "UPLOADED": "Received",
      "PROCESSING": "Processing",
      "READY": "Ready",
      "FAILED": "Failed"
    },
    "retry": "Try again",
    "pickAgain": "Select the file again",
    "linked": "Linked to a lesson"
  },
  "errors": {
    "runFailed": "Couldn't reach the assistant.",
    "createConversation": "Couldn't open the conversation.",
    "deleteConversation": "Couldn't delete the conversation.",
    "upload": "Couldn't upload {{name}}.",
    "loadHistory": "Couldn't load the conversation."
  }
}
